module.exports = __webpack_public_path__ + "html/feedback-swipable_74da50d81867226c4dd2adcf6081ada4.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/feedback-swipable.html
// module id = ApdG
// module chunks = 5 18